import { render, staticRenderFns } from "./AlertOutsideLink.vue?vue&type=template&id=1e96ef57&scoped=true&"
import script from "./AlertOutsideLink.vue?vue&type=script&lang=js&"
export * from "./AlertOutsideLink.vue?vue&type=script&lang=js&"
import style0 from "./AlertOutsideLink.vue?vue&type=style&index=0&id=1e96ef57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e96ef57",
  null
  
)

export default component.exports